<style>
.table td{text-align:left;}

</style>
<template>

  <span style="cursor:pointer;" @click="openModal()">{{ student.name }}</span>



  <div class="modal fade" tabindex="-1" :id="'Modal' + TbtnId" role="dialog" aria-labelledby="myLargeModalLabel"
    aria-hidden="true" v-if="active">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">회원수정</h5>
        </div>
        <div class="modal-body" v-if="!Tstudent.deleted">

          <div>
            <p class="title" style=" font-size:20px; text-align:left;">{{Tstudent.hanName}}({{Tstudent.username}}) 회원</p>
            <div style="display: inline-block; padding: 10px 0 20px; float: right; margin-right: 30px;">
              <button type="button" class="btn btn-dark" data-bs-toggle="modal"
                :data-bs-target="'#ModalExt' + TbtnId"
                style="font-size: 14px!important;">바로연장</button>
                <template v-if="this.$root.guiPerm == 'ROOT'">
                <create-subscription v-if="Tstudent" :student="Tstudent" #default="m" >

              <!--button class="btn btn-danger" style="font-size: 14px!important;"
               @click="m.click()" >구ID주문 </button-->

              </create-subscription>
            </template>
                <create-subscription_new v-if="Tstudent" :student="Tstudent" #default="l" >

                  <button class="btn btn-danger" style="font-size: 14px!important;"
                    @click="l.click()" >ID주문 </button>
                </create-subscription_new>

              <button
                  type="button" class="btn btn-success" style="font-size: 14px!important;" @click="getStudy(Tstudent, true)">학습리포트</button>
              <button type="button" class="btn btn-success" style="font-size: 14px!important;display:none;"
                @click="getStudy(Tstudent)">학습관입장</button>
              <button type="button" class="btn btn-info" style="font-size: 14px!important;" data-bs-toggle="modal"
                :data-bs-target="'#ModalChg' + TbtnId" >레벨변경</button>
                <button type="button" class="btn btn-danger" style="font-size: 14px!important;" data-bs-dismiss="modal" data-bs-toggle="modal"
                            :data-bs-target="'#ModalDel' + TbtnId" @click="checkDeleteAvailable(Tstudent)" v-if="this.$root.guiPerm == 'ROOT'">삭제</button>
            </div>

            <div class="card-header" style="clear:both; background:#fff;">
              <div class="btn-actions-pane-right">



                <div class="nav">
                  <a data-bs-toggle="tab" :href="'#tab-eg2-0' + TbtnId"
                    class=" btn-wide tab_design show active">기본정보</a>
                  <a data-bs-toggle="tab" :href="'#tab-eg2-1' + TbtnId" class=" btn-wide tab_design"
                    @click="this.$refs.qg.search()">주문목록</a>
                  <a data-bs-toggle="tab" :href="'#tab-eg2-2' + TbtnId" class=" btn-wide tab_design">학습현황</a>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="tab-content">
                <div class="tab-pane show active" :id="'tab-eg2-0' + TbtnId" role="tabpanel">
                  <p>
                    <table class="table">

                      <tbody>
                        <colgroup>
                          <col width="">
                        </colgroup>
                        <tr>
                          <th><i class="fas fa-check-circle"></i>소속</th>
                          <td>
                            <tree-btn :tree="this.$refs.biz" />
                          </td>
                          <th>회원번호</th>
                          <td><span v-if="Tstudent.id">{{Tstudent.id}}</span><span v-else>자동222생성</span>
                          </td>
                        </tr>
                        <tr>
                          <th><i class="fas fa-check-circle"></i>아이디</th>
                          <td>
                            {{Tstudent.username}}
                          </td>
                          <th><i class="fas fa-check-circle"></i>비밀번호</th>
                          <td>
                            <input class="hidtype" :value="nvl(changedData.password, Tstudent.password)"
                              :class="{'hidtype-changed': changedData.password}"
                              @input="doChange('password', $event.target.value)" placeholder="비밀번호" />
                            <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.password"
                              @click="delete changedData.password"><i class="bi bi-arrow-counterclockwise"></i></button>
                          </td>
                        </tr>
                        <tr>
                          <th><i class="fas fa-check-circle"></i>이름</th>
                          <td>
                            <input class="hidtype" :value="nvl(changedData.hanName, Tstudent.hanName)"
                              :class="{'hidtype-changed': changedData.hanName}"
                              @input="doChange('hanName', $event.target.value)" placeholder="홍길동" />
                            <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.hanName"
                              @click="delete changedData.hanName"><i class="bi bi-arrow-counterclockwise"></i></button>
                          </td>
                          <th><i class="fas fa-check-circle"></i>영문명</th>
                          <td>
                            <input class="hidtype" :value="nvl(changedData.engName, Tstudent.engName)"
                              :class="{'hidtype-changed': changedData.engName}"
                              @input="doChange('engName', $event.target.value)" placeholder="Gildong Hong" />
                            <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.engName"
                              @click="delete changedData.engName"><i class="bi bi-arrow-counterclockwise"></i></button>
                          </td>
                        </tr>
                        <tr>
                          <th><i class="fas fa-check-circle"></i>성별</th>
                          <td>
                            <select class="hidtype" :value="nvl(changedData.gender, Tstudent.gender)"
                              :class="{'hidtype-changed': changedData.gender}"
                              @input="doChange('gender', $event.target.value)">
                              <option value="1">남</option>
                              <option value="2">여</option>
                            </select>
                            <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.gender"
                              @click="delete changedData.gender"><i class="bi bi-arrow-counterclockwise"></i></button>

                          </td>
                          <th><i class="fas fa-check-circle"></i>학교ID</th>
                          <td>
                                                        <select class="hidtype" :value="nvl(changedData.school_id, Tstudent.school_id)"
                              :class="{'hidtype-changed': changedData.school_id}"
                              @input="doChange('school_id', $event.target.value)">
                              <option value="MyPath">MyPath</option>
                              <option value="kchild408">kchild408</option>
                              <option value="kchild139">kchild139</option>
                              <option value="Edgchildu">Edgchildu</option>
                            </select>
                            <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.school_id"
                              @click="delete changedData.school_id"><i class="bi bi-arrow-counterclockwise"></i></button>

                          </td>
                        </tr>
                        <tr>
                                                    <th><i class="fas fa-check-circle"></i>북클럽</th>
                          <td>
                            <select class="hidtype" :value="nvl(changedData.bookclub_status, Tstudent.bookclub_status)"
                              :class="{'hidtype-changed': changedData.bookclub_status}"
                              @input="doChange('bookclub_status', $event.target.value)">
                              <option value="2" :disabled="this.$root.guiPerm != 'ROOT'">무조건 승인</option>
                              <option value="1">상품 설정에 따르기</option>
                              <option value="0">무조건 차단</option>
                            </select>
                            <button class="btn btn-sm btn-danger" style="display:inline;"
                              v-if="changedData.bookclub_status" @click="delete changedData.bookclub_status"><i
                                class="bi bi-arrow-counterclockwise"></i></button>
                          </td>
                                                    <th><i class="fas fa-check-circle"></i>보카조아</th>
                          <td>
                            <select class="hidtype" :value="nvl(changedData.vocajoa_status, Tstudent.vocajoa_status)"
                              :class="{'hidtype-changed': changedData.vocajoa_status}"
                              @input="doChange('vocajoa_status', $event.target.value)">
                              <option value="2" :disabled="this.$root.guiPerm != 'ROOT'">무조건 승인</option>
                              <option value="1">상품 설정에 따르기</option>
                              <option value="0">무조건 차단</option>
                            </select>
                            <button class="btn btn-sm btn-danger" style="display:inline;"
                              v-if="changedData.vocajoa_status" @click="delete changedData.vocajoa_status"><i
                                class="bi bi-arrow-counterclockwise"></i></button>
                          </td>
                        </tr>
                        <tr>
                                                    <th><i class="fas fa-check-circle"></i>추천인</th>
                          <td><input type="text" class="hidtype" :value="recommender_id" readonly/><button class="btn btn-primary btn-sm" style="font-size:6px; padding:2px 4px;" v-on:click="set_recommender()" v-if="this.$root.guiPerm == 'ROOT'"><i
                                class="bi bi-pencil-fill"></i></button>
                          </td>
                          <th><i class="fas fa-check-circle"></i>자동연장주문</th>
                          <td>
                            <select class="hidtype" :value="nvl(changedData.auto_id_status, Tstudent.auto_id_status)"
                              :class="{'hidtype-changed': changedData.auto_id_status}"
                              @input="doChange('auto_id_status', $event.target.value)">
                              <option value="1">승인1</option>
                              <option value="0">미승인</option>
                            </select>
                            <button class="btn btn-sm btn-danger" style="display:inline;"
                              v-if="changedData.auto_id_status" @click="delete changedData.auto_id_status"><i
                                class="bi bi-arrow-counterclockwise"></i></button>
                          </td>
                        </tr>
                      </tbody>
                    </table>



                    <table class="table">

                      <tbody>
                        <tr>
                          <td style="font-size: 16px; text-align:left; border-top:none;" >부가정보</td>
                        </tr>
                        <!--tr>
                          <th>생년월일</th>
                          <td>
                            <input type="date" class="hidtype"
                              :value="nvl(changedData.birth_of_day, Tstudent.birth_of_day)"
                              :class="{'hidtype-changed': changedData.birth_of_day}"
                              @input="doChange('birth_of_day', $event.target.value)" placeholder="2022-01-01" />
                            <button class="btn btn-sm btn-danger" style="display:inline;"
                              v-if="changedData.birth_of_day" @click="delete changedData.birth_of_day"><i
                                class="bi bi-arrow-counterclockwise"></i></button>
                          </td>
                          <th>학생 전화번호</th>
                          <td>
                            <input class="hidtype" :value="nvl(changedData.phone, Tstudent.phone)"
                              :class="{'hidtype-changed': changedData.phone}"
                              @input="doChange('phone', $event.target.value)" placeholder="010-0000-0000" />
                            <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.phone"
                              @click="delete changedData.phone"><i class="bi bi-arrow-counterclockwise"></i></button>
                          </td>
                        </tr-->
                        <tr>
                          <th><i class="fas fa-check-circle"></i>결제자명</th>
                          <td><input class="hidtype" :value="nvl(changedData.parentName, Tstudent.parentName)"
                              :class="{'hidtype-changed': changedData.parentName}"
                              @input="doChange('parentName', $event.target.value)" placeholder="홍길순" />
                            <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.parentName"
                              @click="delete changedData.parentName"><i
                                class="bi bi-arrow-counterclockwise"></i></button>
                          </td>
                          <th><i class="fas fa-check-circle"></i>학부모 전화번호</th>
                          <td>
                            <input class="hidtype" :value="nvl(changedData.parentPhone, Tstudent.parentPhone)"
                              :class="{'hidtype-changed': changedData.parentPhone}"
                              @input="doChange('parentPhone', $event.target.value)" placeholder="010-0000-0000" />
                            <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.parentPhone"
                              @click="delete changedData.parentPhone"><i
                                class="bi bi-arrow-counterclockwise"></i></button>
                          </td>
                        </tr>
                        <tr>
                          <!--th><i class="fas fa-check-circle"></i>주소</th>
                          <td>
                            <input class="hidtype" :value="nvl(changedData.address, Tstudent.address)"
                              :class="{'hidtype-changed': changedData.address}"
                              @input="doChange('address', $event.target.value)" placeholder="서울 영등포구 국회의사당로 1" />
                            <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.address"
                              @click="delete changedData.address"><i class="bi bi-arrow-counterclockwise"></i></button>
                          </td-->
                          <th>Pass 기능(언어훈련관 스킵)</th>
                          <td>

                            <select class="hidtype" :value="nvl(changedData.pass_allowed, Tstudent.pass_allowed)"
                              :class="{'hidtype-changed': changedData.pass_allowed}"
                              @input="doChange('pass_allowed', $event.target.value)">
                              <option :value="true">허용</option>
                              <option :value="false">차단</option>
                            </select>
                            <button class="btn btn-sm btn-danger" style="display:inline;"
                              v-if="changedData.pass_allowed" @click="delete changedData.pass_allowed"><i
                                class="bi bi-arrow-counterclockwise"></i></button>

                                </td>
                        </tr>
                                                <tr v-if="this.$root.guiPerm == 'ROOT'">
                          <th><i class="fas fa-check-circle"></i>ChildU 상태</th>
                          <td>
                                                        <select class="hidtype" :value="nvl(changedData.myuse_id_status, Tstudent.myuse_id_status)"
                              :class="{'hidtype-changed': changedData.myuse_id_status}"
                              @input="doChange('myuse_id_status', $event.target.value)">
                              <option :value="true">사용</option>
                              <option :value="false">해지</option>
                            </select>
                            <button class="btn btn-sm btn-danger" style="display:inline;"
                              v-if="changedData.myuse_id_status" @click="delete changedData.myuse_id_status"><i
                                class="bi bi-arrow-counterclockwise"></i></button>

                          </td>
                          <th>MyPath 상태</th>
                          <td>
                            <select class="hidtype" :value="nvl(changedData.mypath_id_status, Tstudent.mypath_id_status)"
                              :class="{'hidtype-changed': changedData.mypath_id_status}"
                              @input="doChange('mypath_id_status', $event.target.value)">
                              <option :value="true">사용</option>
                              <option :value="false">해지</option>
                            </select>
                            <button class="btn btn-sm btn-danger" style="display:inline;"
                              v-if="changedData.mypath_id_status" @click="delete changedData.mypath_id_status"><i
                                class="bi bi-arrow-counterclockwise"></i></button>

                                </td>
                        </tr>
                                                <tr  v-if="this.$root.guiPerm == 'ROOT'">
                          <th>아이디 상태 변경일</th>
                          <td>
                            {{ Tstudent.id_status_last_update}}
                          </td>
                          <th>ChildU(M) 상태</th>
                          <td>
                            <select class="hidtype" :value="nvl(changedData.childum_id_status, Tstudent.childum_id_status)"
                              :class="{'hidtype-changed': changedData.childum_id_status}"
                              @input="doChange('childum_id_status', $event.target.value)">
                              <option :value="true">사용</option>
                              <option :value="false">해지</option>
                            </select>
                            <button class="btn btn-sm btn-danger" style="display:inline;"
                              v-if="changedData.childum_id_status" @click="delete changedData.childum_id_status"><i
                                class="bi bi-arrow-counterclockwise"></i></button>

                                </td>
                        </tr>
                      </tbody>
                    </table>
                    <table class="table" >
                      <tbody>
                        <tr>
                          <td style="font-size: 16px; text-align:left; border-top:none;" colspan="4">학습정보</td>
                        </tr>
                        <tr>
                          <th width="25%">ID 시작일</th>
                          <td>
                            {{Tstudent.start_date}}
                          </td>
                          <th>ID 종료일</th>
                          <td>
                            {{Tstudent.end_date}}
                          </td>
                        </tr>
                        <tr>
                          <th>학습상태</th>
                          <td>
                            <span v-if="Tstudent.status == 'WAITING_PAYMENT'">결제 대기 중</span>
                            <span v-if="Tstudent.status == 'PAYMENT_LATE'">결제 만료</span>
                            <span v-if="Tstudent.status == 'ACTIVE'">사용 중</span>
                            <span v-if="Tstudent.status == 'PENDING'">대행 대기 중</span>
                            <span v-if="Tstudent.status == 'ENDED'">정상 종료</span>
                            <span v-if="Tstudent.status == 'CANCELLED'">취소됨</span>
                            <span v-if="Tstudent.status == 'RESERVED'">연장</span>
                            <span v-if="Tstudent.status == 'CONFIRMING_PAYMENT'">결제 확인 중</span>
                            <span v-if="Tstudent.status == 'CANCEL_PENDING'">취소승인 대기 중</span>
                          </td>
                          <th>만료일</th>
                          <td>
                            {{Tstudent.end_date_plus_five}}
                          </td>
                        </tr>
                        <tr>
                          <th>학습유형</th>
                          <td>
                            <span v-if="Tstudent.type == 'ChildUM'">ChildU(M)</span>
                            <span v-else> {{Tstudent.type}}</span>                           
                          </td>
                          <th>학습레벨</th>
                          <td>
                            {{Tstudent.level}}
                                </td>
                        </tr>
                        <template v-if="Tstudent.type == 'ChildUM' ">
                        <tr>
                          <th>학습과목 </th>
                          <td colspan="3" style='text-align: left;padding-left: 30px;'>
                            <input type="checkbox" v-model="LA" /> Language Arts
                            <input type="checkbox" v-model="MA" />Math 
                            <input type="checkbox" v-model="SC" /> Science 
                            <input type="checkbox" v-model="SS" />Social Studies 
                                

                          <template  v-if="this.$root.guiPerm == 'ROOT'" >
                            <button class="btn btn-success " style="padding:4px 10px;margin-left:30px" @click="subjectChng()" >변경</button>   
                          </template>    
                          <template v-else>
                            <button class="btn btn-success " style="padding:4px 10px;margin-left:30px" @click="requestLevel('subject')" >변경신청</button>   
                          </template>
                          </td>                       
                        </tr>
                      </template>
                      </tbody>
                    </table>
                    <table class="table" v-if="this.Tstudent.alpha !== null">
                      <tr>
                        <td colspan="6" style="background:#f6f7f8;">
                          점수획득 현황 <button type="button" class="btn btn-info" style="font-size: 14px!important;" data-bs-toggle="modal"
                          :data-bs-target="'#PointModal' + TbtnId" v-if="this.$root.guiPerm == 'ROOT'" >학습점수관리</button>
                        </td>
                      </tr>
                      <tr>
                        <th>
                          FAME
                        </th>
                        <td>
                          {{ this.Tstudent.fame }}점
                        </td>
                        <th>
                          ALPHA
                        </th>
                        <td>
                          {{ this.Tstudent.alpha }}점
                        </td>
                        <th>
                          CARAT
                        </th>
                        <td>
                          {{ this.Tstudent.carat }}점
                        </td>
                      </tr>
                    </table>


                    <br>
                    <table class="table">
                      <tr>
                        <th colspan="4" style="height:50px;">
                          관리메모
                        </th>

                      </tr>
                      <tr v-for="memo in Tstudent.memos" :key="memo.id">

                        <td style="width:50%; text-align:left;">
                          {{ memo.text }}
                        </td>
                        <td>
                          {{ memo.admin_name }}
                        </td>
                        <td>
                          {{ memo.created_at }}
                        </td>
                        <td>
                          <a @click="delMemo(memo.id)"><button class="btn btn-danger btn-sm">삭제</button></a>
                        </td>

                      </tr>
                    </table>
                    <table class="table">
                      <tr>
                        <th>
                          메모작성
                        </th>
                        <td style="height:60px;">
                          <input type="text" class="form-control" placeholder="여기에 메모를 작성 .."
                            v-model="this.Tstudent.memo" />
                        </td>
                        <td style="text-align:right; width:100px;">
                          <button class="btn btn-success " style="padding:4px 10px;" @click="addMemo(Tstudent)">작성</button>
                        </td>
                      </tr>

                    </table>
                  </p>
                  <div class="modal-footer flex_center">
                    <button type="button" class="btn btn-warning" @click="doSend()">학생정보
                      수정</button>
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">닫기</button>
                  </div>

                </div>
                <div class="tab-pane show " :id="'tab-eg2-1' + TbtnId" role="tabpanel">
                  <query-grid :config="config_subscriptions" ref="qg">
          <template #items="props">
<tr v-for="subscription in props.records" v-bind:key="subscription.id">
              <td scope="col" style="font-size:12px;"><Subscription :subscription="subscription" :ref="'sub' + subscription.id"></Subscription>&nbsp;<span style="background:#ccc; color:#000; padding:1px 3px 1px 2px; border-radius:2px; font-size:12px;" v-if="subscription.previous_order">연장</span></td>
              <td scope="col">{{ subscription.createdAt }}</td>
              <td scope="col">{{ subscription.productName }}</td>
              <td scope="col">{{ subscription.period }}</td>
              <td scope="col">{{ subscription.level }}</td>
              <td scope="col">
                <template v-if="subscription.paymentMethod == 'CARD_ONPG'"><span style="font-size:10px; background:#00acea; padding:2px 4px; color:#fff; border-radius:4px; border:1px solid #0095ea;">신용카드</span></template>
                <template v-if="subscription.paymentMethod == 'CARD_OFFPG'"><span style="font-size:10px; background:#0084ea; padding:2px 4px; color:#fff; border-radius:4px; border:1px solid #0095ea;">신용카드(오프)</span></template>
                <template v-if="subscription.paymentMethod == 'CASH'"><span style="font-size:10px; background:#eb4e4e; padding:2px 4px; color:#fff; border-radius:4px; border:1px solid #e92222;">현금</span></template>

                </td>
              <td scope="col">{{ parseInt(subscription.price).toLocaleString() }}원</td>
              <td scope="col">{{ subscription.endDate }}</td>
              <td scope="col"> <span v-if="subscription.status == 'WAITING_PAYMENT'">결제대기</span>
              <span v-if="subscription.status == 'PAYMENT_LATE'">결제 만료</span>
                <span v-if="subscription.status == 'ACTIVE'">사용중</span>
                <span v-if="subscription.status == 'PENDING'">대행대기</span>
                <span v-if="subscription.status == 'ENDED'">만료됨</span>
                <span v-if="subscription.status == 'CANCELLED'">취소됨</span>
                <span v-if="subscription.status == 'RESERVED'">연장</span>
                <span v-if="subscription.status == 'CONFIRMING_PAYMENT'">결제 확인 중</span>
                <span v-if="subscription.status == 'CANCEL_PENDING'">취소승인 대기</span></td>



            </tr>
          </template>

        </query-grid>

                  <div class="modal-footer flex_center">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">닫기</button>
                  </div>

                </div>
                <div class="tab-pane show" :id="'tab-eg2-2' + TbtnId" role="tabpanel">
                  <!--div class="input-group mb-12">
                        <div class="input-group-prepend">
                          <select class="custom-select flex_center" id="inputGroupSelect01">
                            <option selected>Assignment</option>
                            <option value="1">Assignment</option>
                            <option value="2">test</option>
                          </select>
                        </div>
                      </div-->
                  <!-- 레벨테스트는 추후 생각해보기로 하자
                      레벨테스트
                      <table class="table">
                        <thead>
                          <tr>
                            <td class="th_bg">No</td>
                            <td class="th_bg">name</td>
                            <td class="th_bg">DATE</td>
                            <td class="th_bg">GRADE</td>
                            <td class="th_bg">Result</td>

                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(test, index) in tests" v-bind:key="test.intNo">
                            <td>{{ index + 1 }}</td>
                            <td>{{ test.t_name }}</td>
                            <td>{{ test.t_startdate.substr(0, 10) }}</td>
                            <td>{{ test.strGrade }}</td>
                            <td>{{ test.t_total }} 점</td>

                                            </tr>
                                          </tbody>

                                        </table>
                                        -->
                  <table class="table">
                    <thead>
                      <tr>
                        <td class="th_bg">DATE</td>
                        <td class="th_bg">GRADE</td>
                        <td class="th_bg">Course</td>
                        <td class="th_bg">Subject</td>
                        <td class="th_bg">Progress</td>
                        <td class="th_bg">Status</td>
                        <td class="th_bg">Complete(date)</td>
                        <td class="th_bg">admin</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="AccData in AccDatas" v-bind:key="AccData.intNo">
                        <td>{{ AccData.datAssign.substr(0, 10) }}</td>
                        <td>{{ AccData.strGrade }}</td>
                        <td>{{ AccData.strCourse }}</td>
                        <td>{{ AccData.strSubject }}</td>
                        <td>{{ AccData.intDone }} / {{ AccData.intTotal }}</td>
                        <td>{{ AccData.strState }}</td>
                        <td><span v-if="AccData.datEnd">{{ AccData.datEnd.substr(0, 10) }}</span>
                        </td>
                        <td>
                          <button class="btn btn-danger btn-sm" data-bs-toggle="modal"
                            :data-bs-target="'#ModalAdm' + TbtnId"
                            @click="getCurrent(AccData.intMemberID, AccData.strGrade, AccData.strCourse, AccData.strSubject)">ADMIN</button>
                          


                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="input-group mb-12">

                  </div>




                </div>
              </div>
            </div>






          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="modal fade bd-example-modal-admin"  :id="'ModalAdm' + TbtnId" tabindex="-1" role="dialog"
    aria-labelledby="myLargeModalLabel" aria-hidden="true" style="background:rgba(0,0,0,0.8);">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">
            학습진도 처리(관리자용)</h5>
        </div>
        <div class="modal-body">

          해당학습의 Assign(진도현황)을 조절할 수 있으며 Admin 처리한 학습의 경우 점수가
          부여되지 않습니다
          <table class="table">
            <tbody>
              <tr>
                <td class="th_bg">GRADE</td>
                <td>{{ strGrade }}

                </td>
                <td class="th_bg">Subject</td>
                <td>
                  {{ strSubject }}
                </td>
              </tr>
              <tr>
                <td colspan="4" style="background:#eee;">
                  <div style="background:#246181; color:#fff;">
                    학습완료로 처리할 DAY를 체크해주세요!</div>
                  <div>
                    <ul class="admin-ul">
                      <li v-for="(history, index) in historys" v-bind:key="index"
                        style="text-align:left; width:160px; height:24px; padding:10px 0px 20px 0px;">
                        <input type="checkbox" v-model="admCheck" :value="index" v-if="!history">
                        <input type="checkbox" disabled checked v-if="history">
                        <span style="font-size:12px; padding:1px 4px; border-radius:2px;margin:4px; background:#00acea; color:#fff;">{{ index }}&nbsp; DAY</span>
                        <span @click="AdminEND(index)" v-if="history && this.$root.guiPerm == 'ROOT1'" style="font-size:12px; padding:1px 4px; border-radius:2px;margin:4px; background:#ff0000; color:#fff;">E</span>
                        <span v-if="dhistorys[index]">{{ dhistorys[index].toString().substr(2, 8) }}</span>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody>

            </tbody>
          </table>
          <div class="flex_center">
            <button class="btn btn-danger" @click="AdminAcc()">ADMIN 처리</button>
            <button class="btn btn-secondary" data-bs-dismiss="modal">취소</button>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="modal fade" :id="'ModalChg' + TbtnId" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
    aria-hidden="true" style="background:rgba(0,0,0,0.8);">
    <div class="modal-dialog modal-sms">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">레벨변경</h5>

        </div>
        <div class="modal-body">
          <p style="text-align:left;"><!--<template v-if="this.$root.guiPerm != 'ROOT'">-->
            <i class="bi bi-info-circle"></i> 변경 이력은 학습변경관리 에서 확인 가능합니다.<br><!--</template>-->
            <i class="bi bi-info-circle"></i> <span style="color:#ff0000;">중고등 상품의 레벨변경은 본사로 신청 접수해 주세요.</span>
            </p>
          <table class="table">
            <tbody>
              <tr>
                <td class="th_bg">이용상품</td>
                <td colspan="3"> <select class="hidtype" v-model="levelRequest.record">
                    <template :key="subscription.id" v-for="subscription in subscriptions">
                      <option :key="subscription.id" :value="subscription" v-if="subscription.status == 'ACTIVE' && (subscription.product == 'ChildU' || subscription.product == 'ChildUM')">
                        {{ subscription.productName }}</option>
                    </template>
                  </select></td>

              </tr>
              <tr>
                <td class="th_bg">현재레벨</td>
                <td>{{ levelRequest.record.level}}</td>
                <td class="th_bg">변경레벨</td>
                <template v-if="this.$root.guiPerm == 'ROOT' || this.$root.guiPerm == 'LOCAL1'">
                    <td><select class="hidtype" v-model="levelRequest.level" v-if="levelRequest.record">
                      <option value="RE">초기화</option>
                      <option value="GK">GK</option>
                      <option value="GK_1" v-if="levelRequest.record.product == 'ChildU'">GK_1</option>
                      <option value="GR1">GR1</option>
                      <option value="GR2">GR2</option>
                      <option value="GR3">GR3</option>
                      <option value="GR4">GR4</option>
                      <option value="GR5">GR5</option>
                      <template v-if="levelRequest.record.product == 'MYPATH' || levelRequest.record.product == 'ChildUM' ">
                      <option value="GR6">GR6</option>
                      <option value="GR7">GR7</option>
                      <option value="GR8">GR8</option>
                      <option value="GR9">GR9</option>
                      <option value="GR10">GR10</option>
                      <option value="GR11">GR11</option>
                      <option value="GR12">GR12</option>
                      </template>                     
                    </select></td>
                  </template>
                  <template v-else>
                    <template v-if="this.$root.businesses[0].study_type != 'ALS'">
                      <td><select class="hidtype" v-model="levelRequest.level" v-if="levelRequest.record">
                        <option value="RE">초기화</option>
                        <option value="GK">GK</option>
                        <option value="GK_1" v-if="levelRequest.record.product == 'ChildU'">GK_1</option>
                        <option value="GR1">GR1</option>
                        <option value="GR2">GR2</option>
                        <option value="GR3">GR3</option>
                        <option value="GR4">GR4</option>
                        <option value="GR5">GR5</option>
                        <template v-if="levelRequest.record.product == 'MYPATH' || levelRequest.record.product == 'ChildUM' ">
                        <option value="GR6">GR6</option>
                        <option value="GR7">GR7</option>
                        <option value="GR8">GR8</option>
                        <option value="GR9">GR9</option>
                        <option value="GR10">GR10</option>
                        <option value="GR11">GR11</option>
                        <option value="GR12">GR12</option>
                        </template>
                      </select></td>
                    </template>
                    <template v-else>
                      <td><select class="hidtype" v-model="levelRequest.level" v-if="levelRequest.record">
                        <option value="RE">초기화</option>
                        <option value="Sprout">Sprout</option>
                        <option value="Blow">Blow</option>
                        <option value="Flag">Flag</option>
                        <option value="Wing">Wing</option>
                        <option value="Dream">Dream</option>
                        <option value="Royal">Royal</option>
                      </select></td>
                    </template>
                  </template>
              </tr>
            </tbody>
          </table>
          <div class="flex_center">
            <template v-if="levelRequest.record.product == 'ChildUM' ">
            <button class="btn btn-danger" data-bs-dismiss="modal" @click="requestLevel('req')">신청하기</button>
            </template>
            <template v-else>
            <button class="btn btn-danger" data-bs-dismiss="modal" @click="requestLevel('chng')">변경하기</button>
            </template>
          </div>
          <template v-if="levelRequest.record.product !== 'ChildUM' ">
          <span style="color:#ff0000; font-weight: bold;">'변경하기' 클릭 시 즉시 변경됩니다.</span>
        </template>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" :id="'PointModal' + TbtnId" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
    aria-hidden="true" style="background:rgba(0,0,0,0.8);">
    <div class="modal-dialog modal-lg" >
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="editModalLabel"> 학습점수관리</h5>

        </div>
        <div class="modal-body">
          <p style="text-align:left;"><!--<template v-if="this.$root.guiPerm != 'ROOT'">-->
            <i class="bi bi-info-circle"></i> 변경 이력은 학습점수관리에서 확인 가능합니다.<br><!--</template>-->
            </p>
            <table class="table">
            <tbody>
              <tr>
                <th>선택회원</th>
                <td style="text-align:center;">
                  <input 
                        type="text"
                        class="hidtype"                   
                        :value="nvl(changedData.hanName, Tstudent.hanName)"
                        readonly        
                      />         
                      <input type="hidden" v-model="Tstudent.id" />   
                </td>
                <th>유형</th>
                <td colspan="3" style="text-align:center;" >
                    <select class="hidtype" v-model="Psub.chrGubun">
                    <option value="P" selected>적립</option>
                    <option value="M">차감</option>
                  </select>
                </td>
              </tr>
              <tr>
                <th>종류</th>
                <td style="text-align:center;">
                    <select class="hidtype" v-model="Psub.chrPType" >
                    <option value="" selected>선택</option>
                    <option value="A">ALPHA</option>
                    <option value="C">CARAT</option>
                    <option value="F">FAME</option>                
                  </select>
                </td>
                <th style="width:13%">점수</th>
                <td style="text-align:center;width:10%;padding-left: 10px;">            
                    <select class="hidtype" @input="pointDoChange('intPoint', $event.target.value)" v-model="Psub.setPoint" >
                    <option value="" selected>선택</option>
                    <option value="100">100</option>
                    <option value="200">200</option>
                    <option value="300">300</option>
                    <option value="400">400</option>
                    <option value="500">500</option>
                    <option value="1000">1000</option>
                    <option value="2000">2000</option>
                    <option value="3000">3000</option>
                    <option value="5000">5000</option>
                    <option value="self">직접입력</option>
                  </select>
                </td>
                <td style="text-align:center;width:18%">       
                  <input type="number" class="form-control" style='width:70%;margin-left:20px'  v-model="Psub.intPoint" id = "intPoint" readonly @input="inputNumber($event)"
                  oninput="this.value = this.value.replace(/[^0-9.]/g, '')" >
                  
                </td>
              </tr>
              <tr>
                <th>내용</th>
                <td colspan="5" style="text-align:center;">
                  <input type="text" class="form-control" style='width:95%;margin-left:20px' placeholder="여기에 내용을 작성 .." maxlength = "20"
                  v-model="Psub.strHistory" />
                </td>            
              </tr>          
            </tbody>
          </table>
          <div style="text-align:left; font-size:14px; line-height:10px; margin:0px; padding:10px 20px; " >
            <p style="color:red">[관리 안내]</p>
            <p>- 선택된 모든 회원에게 일괄 처리되므로 관리할 내용과 회원이 정확한지 꼭 확인해 주세요!</p> 
          </div>
          <div class="flex_center">     
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"> 닫기</button>
            <button type="button" class="btn btn-danger" @click="addPoint()">등록</button>
          </div>
          <span style="color:#ff0000; font-weight: bold;">'등록' 클릭 시 즉시 반영됩니다.</span>
        </div>
      </div>
    </div>
  </div>


  <div class="modal fade bd-example-modal-extend" tabindex="-1" role="dialog" :id="'ModalExt' + TbtnId" aria-labelledby="myLargeModalLabel"
    aria-hidden="true" style="background:rgba(0,0,0,0.8);">
    <div class="modal-dialog modal-sms">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">연장</h5>

        </div>
        <div class="modal-body">



          <p>※ [ACTIVE]와 [RESERVED]가 있는 경우 <strong style="font-weight: 700; color:red;">[RESERVED]를 선택해 주세요.</strong></p>
          <table class="table">
            <tbody>
              <tr>
                <td class="th_bg">이용상품</td>
                <td colspan="3"> <select class="hidtype" v-model="extendRequest.record"
                    @change="this.fetchProducts(extendRequest.record);">
                    <template :key="subscription.id" v-for="subscription in subscriptions">
                      <option :value="subscription" v-if="subscription.status == 'ACTIVE' || subscription.status == 'RESERVED'">
                        {{ subscription.productName }} [{{subscription.status}}]</option>
                    </template>
                  </select></td>

              </tr>
              <tr>
                <td class="th_bg">연장상품</td>
                <td colspan="3"> <select class="hidtype" v-model="extendRequest.product">
                    <template :key="product.id" v-for="product in products">
                      <option :value="product">
                        {{ product.name }} ({{product.price}}원)</option>
                    </template>
                  </select></td>

              </tr>
                            <tr>
                <td class="th_bg">결제수단</td>
                <td colspan="3"> <select class="hidtype" v-model="extendRequest.payMethod">
                          <option disabled value="">결제방식을 선택해 주세요</option>
                          <option value="CARD_ONPG">온라인 신용카드(문자전송)</option>
                          <option value="CASH">현금(자동세팅 불가)</option>
                          <option value="CARD_OFFPG" disabled>오프라인 신용카드(개발중)</option>
                  </select></td>

              </tr>
            </tbody>
          </table>
          <div style="text-align:left; font-size:14px; line-height:20px; margin:0px; border:1px solid #ccc; padding:10px 20px; background:#f8f8f8;" >
             - 연장 주문은 아이디 만료 이전에 가능하며, 종료일 7일 경과 후<br/>&nbsp;&nbsp;아이디가 만료됩니다.
            </div>

          <div class="flex_center">
            <button class="btn btn-danger" data-bs-dismiss="modal" @click="requestExtend()">연장신청</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade deleteModal"  tabindex="-1" role="dialog" :id="'ModalDel' + TbtnId" aria-labelledby="myLargeModalLabel" aria-hidden="true"
    style="background:rgba(0,0,0,0.8);">
    <div class="modal-dialog modal-sms modal-fullscreen">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">기관 삭제 유효성 검사</h5>

        </div>
        <div class="modal-body">
          <table class="table">
            <thead>
              <tr scope="row">
                <td>타입</td>
                <td>메시지</td>
                <td>데이터</td>
              </tr>
            </thead>
            <tbody>
              <template v-for="(error, i) in deletingErrors" :key="i">
                <tr v-if="error.level != 'WARNING' || showWarn">
                  <td>
                    <template v-if="error.level == 'WARNING'"><i class="bi bi-exclamation-triangle-fill"></i></template>
                    <template v-if="error.level == 'ERROR'"><i class="bi bi-x-circle-fill"></i></template>
                    <template v-if="error.level == 'SUCCESS'"><i class="bi bi-check"></i></template>
                  </td>
                  <td>{{ error.error }}</td>
                  <td>{{ error.data_name}}</td>
                </tr>
              </template>
            </tbody>
          </table>
          오류 {{ errCnt }}개, 경고 {{ warnCnt }}개 (<input type="checkbox" v-model="showWarn">경고 보기)
          <div class="flex_center">
            <button class="btn btn-info" data-bs-dismiss="modal">취소</button>
            <button class="btn btn-danger" data-bs-dismiss="modal" :disabled="!deletingPermitted"
              @click="commitDelete(Tstudent)">삭제</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Tree :key="$route.path" :tree-data="this.$root.businesses" :selectable="['CLASS']" render-button :callback="selectedBiz"
    :selectedNode="{'id': Tstudent.activeBusiness}" ref="biz" v-if="active" />


</template>

<script>
  import Tree from "../Tree";
  import axios from "axios";
  import treeBtn from "../treeBtn";
  import VueCookies from 'vue-cookies';
import Subscription from './Subscription.vue';
import QueryGrid from '../QueryGrid.vue'
import CreateSubscription from '../CreateSubscription.vue'
import CreateSubscription_new from '../CreateSubscription_new.vue'
  export default {
    name: "student",
    watch: {
      student(){

      this.Tstudent = this.student;
      this.config_subscriptions.extras_addon =  async ()=>{
      return "&student=" + this.student.id
    }

      }
    },
    methods: {
       //과목배열 점검
       custom_filter(a, b) {
        if (a.indexOf(b) !== -1) {
          return true;
        }else{
        return false;
        }
      },
      addPoint() {
  
  if(this.Psub.chrPType==""){
    alert('종류를 선택해주세요.');   
    return;
  }
  if(this.Psub.intPoint==""){
    alert('점수를 입력해주세요.');   
    return;
  }
  var data = {
    chrGubun: this.Psub.chrGubun,
    chrPType: this.Psub.chrPType,
    intPoint: this.Psub.intPoint,
    strHistory: this.Psub.strHistory,
    intMemberID: this.Tstudent.id,
  };
  //console.log(data);
  var send = axios({
    method:"post",
    url:
       "/students/pointIn_v2/",
    data: data,
  });
  send.then((response) => {
    if (response.data.error) {
      $.notify(
        {
          // options
          message: "처리할 수 없습니다 " + response.data.error,
        },
        {
          // settings
          type: "danger",
          z_index: 9999,
        }
      );
    } else {
      $.notify(
        {
          // options
          message: "처리되었습니다",
         
        },
        {
          // settings
          type: "success",
          z_index: 9999,
        }
      );
     
      (bootstrap.Modal.getInstance(document.getElementById('PointModal' + this.TbtnId))).hide();
      this.moreStudentInfo();
    }
  });
},

inputNumber(event){
      this.result = event.target.value
    },

      pointDoChange(name, value) {
        if (value == "self") {          
          this.Psub.setPoint = "self";
          this.Psub.intPoint = "";
          document.getElementById("intPoint").readOnly  = false;          
        } else {
          this.Psub.setPoint = value;
          this.Psub.intPoint = value;
          document.getElementById("intPoint").readOnly  = true;     
        }
      },
      doChange(name, value) {
        if (this.Tstudent[name] === value) {
          delete this.changedData[name];
        } else {
          this.changedData[name] = value;
        }
      },
      selectedBiz(biz) {
        this.selBiz = biz;
        this.changedData.activeBusiness = biz.id;
      },
      moreStudentInfo() {
        $('a[href="#tab-eg2-0"]').tab('show');
        this.creating = false;
        this.changedData = {};
        axios.get('/students/' + this.Tstudent.id).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.Tstudent = {
              ...this.Tstudent,
              ...response.data.result
            };
            this.tests = response.data.t_test;
            this.AccDatas = response.data.acclist;
            this.$refs.biz.reset(this.Tstudent.biz);
            this.recommender_id = response.data.recommender_id;
            //console.log(this.AccDatas);
            this.subsc = response.data.subsc;
           
            this.LA = false;
            this.MA = false;
            this.SC = false;
            this.SS = false;
            if(this.Tstudent.subject_arr.indexOf('LA') !== -1){
            this.LA = true;
            }
            if(this.Tstudent.subject_arr.indexOf('MA') !== -1){
              this.MA = true;
            }
            if(this.Tstudent.subject_arr.indexOf('SC') !== -1){
              this.SC = true;
            }
            if(this.Tstudent.subject_arr.indexOf('SS') !== -1){
              this.SS = true;
            }

          }


        })
        axios.get('/students/' + this.Tstudent.id + '/scores').then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.Tstudent.alpha = response.data.alpha
            this.Tstudent.fame = response.data.fame
            this.Tstudent.carat = response.data.carat
          }


        })

                axios.get('/students/' + this.Tstudent.id + '/pass').then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.Tstudent.pass_allowed = response.data.pass_allowed
          }


        })

      
        //학습과목수 가져오기
        axios.get('/students/' + this.Tstudent.id + '/subject_cnt').then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.Tstudent.subject_cnt = response.data.subject_cnt
          }


        })










      },
      //과목변경신청
      subjectChng(count) {
        var subject_arr_update = "";
        var cnt = 0;
        if(this.LA === true){
          subject_arr_update = "LA,";
          cnt++;
        } 
        if(this.MA === true){
          subject_arr_update = subject_arr_update + "MA,";
          cnt++;
        }
        if(this.SC === true){
          subject_arr_update = subject_arr_update + "SC,";
          cnt++;
        }
        if(this.SS === true){
          subject_arr_update = subject_arr_update + "SS,";
          cnt++;
        }
        //console.log("subject_arr_update:"+subject_arr_update);
       // console.log("cnt:"+parseInt(cnt));
        //console.log("subject_cnt:"+parseInt(this.Tstudent.subject_cnt));
        
        if(parseInt(cnt) !== parseInt(this.Tstudent.subject_cnt)){
          alert('선택할 수 있는 과목수가 다릅니다. 확인해주세요.\n(선택 가능한 과목수: '+this.Tstudent.subject_cnt+'개)');
          return;
        }

        //return;

        
        axios.patch('/students/' + this.Tstudent.id + '/subject', {
          "subject_arr": subject_arr_update
        }).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '변경이 실패하였습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            $.notify({
              // options
              message: '변경이 완료되었습니다. '
            }, {
              // settings
              type: 'success',
              z_index: 9999
            });
            this.moreStudentInfo();

          }


        })
        
      },
      set_recommender() {
        var record = this.Tstudent;
        //console.log(record.id);

        var new_recommender = prompt("추천인 회원번호를 입력하세요. 예: 71710");
        if (!new_recommender) return;
        axios.patch('/recommender/' + record.id, {
          new_recommender: new_recommender
        }).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            console.log(response.data.data);
            $.notify({
              // options
              message: '성공하였습니다.'
            }, {
              // settings
              type: 'success',
              z_index: 9999
            });
            this.recommender_id = response.data.data;
            //this.recommender_id = response.data.recommender_id;
          }


        })
      },
      AdminAcc() {
        console.log(this.strGrade);
        axios.post('/privileges', {
          'value': this.admCheck,
          'intMemberID': this.intMemberID,
          'strGrade': this.strGrade,
          'strCourse': this.strCourse,
          'strSubject': this.strSubject
        }).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: 'ADMIN 처리 실패: ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.admCheck.splice(0);
            this.historys = response.data.result;
            this.dhistorys = response.data.result_D;
          }


        })
      },
      AdminEND(record) {
        console.log(record);
        axios.post('/privilegesN', {
          'AccTime': record,
          'intMemberID': this.intMemberID,
          'strGrade': this.strGrade,
          'strCourse': this.strCourse,
          'strSubject': this.strSubject
        }).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: 'ADMIN 처리 실패: ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            $.notify({
              // options
              message: '처리되었습니다'
            }, {
              // settings
              type: 'success',
              z_index: 9999
            });
          }


        })
      },
      doSend() {
        // 업데이트일 경우 patch /businesses/번호
        // 신규일 경우 post /businesses 후 post /admins 후 post /admins/번호/grants
        var data = {};
        if (this.creating) {
          data = {
            ...this.Tstudent,
            ...this.changedData,
            'activeBusiness': this.selBiz.id,
            'product': this.selProduct.id,
            'paymentMethod': this.Tstudent.payMethod,
            'hopeStart': this.Tstudent.hopeStart,
            'level': this.Tstudent.level
          };
        } else {
          data = this.changedData;
        }
        axios({
          method: this.creating ? "post" : "patch",
          url: '/students' + (!this.creating ? "/" + this.Tstudent.id : ""),
          data: data
        }).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '처리할 수 없습니다 ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.search()
            $.notify({
              // options
              message: '학생 생성이 처리되었습니다'
            }, {
              // settings
              type: 'success',
              z_index: 9999
            });
            (bootstrap.Modal.getInstance(document.getElementById("studentModal"))).hide();
            if (this.Tstudent.addSubscription) {
              $.notify({
                // options
                message: '아이디 생성을 처리중입니다'
              }, {
                // settings
                type: 'info',
                z_index: 9999
              });

              axios.post('/subscriptions', {
                'student': response.data.id,
                'product': this.selProduct.id,
                'paymentMethod': this.Tstudent.payMethod,
                'hopeStart': this.Tstudent.hopeStart,
                'level': this.Tstudent.level,
                "subject":""
              }).then((response) => {
                if (response.data.error) {
                  $.notify({
                    // options
                    message: 'ID 추가 실패: ' + response.data.error
                  }, {
                    // settings
                    type: 'danger',
                    z_index: 9999
                  });
                } else {
                  if (confirm("아이디까지 같이 신청이 완료되었습니다. 결제창으로 이동할까요?")) {
                    this.$router.push("/subscriptions?id=" + response.data.id);
                  } else {
                    this.search()
                    $.notify({
                      // options
                      message: '아이디 신청되었습니다.'
                    }, {
                      // settings
                      type: 'success',
                      z_index: 9999
                    });
                  }

                }


              })


            }


          }


        })


      },
      getCurrent(intMemberID, strGrade, strCourse, strSubject) {

        this.admCheck.splice(0);

        axios.post('/studentUp', {
          'intMemberID': intMemberID,
          'strGrade': strGrade,
          'strCourse': strCourse,
          'strSubject': strSubject
        }).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            console.log(intMemberID);
            this.historys = response.data.result;
            this.dhistorys = response.data.result_D;
          }

          this.strGrade = strGrade;
          this.strCourse = strCourse;
          this.strSubject = strSubject;
          this.intMemberID = intMemberID;

        })
      },
      fetchSubscriptions() {
        var extras = "";
        this.levelRequest.record = {};
        axios.get('/subscriptions?student=' + this.Tstudent.id).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.subscriptions = response.data.result;
            if(response.data.length){
            this.extendRequest.record = response.data.result[0];
            this.levelRequest.record = response.data.result[0];
            this.fetchProducts(response.data.result[0])
            this.extendRequest.payMethod = this.extendRequest.record.paymentMethod
            } else {
              this.fetchProducts()
            }

          }


        })
      },
      getStudy(record, is_report) {
        // 유저단에서 인증요청 후 redir 보내기

        axios.post('https://api.mypathkr.com/oauth/login', {
          'grant_type': "admin_access_token",
          'access_token': VueCookies.get("access_token"),
          'id': record.id
        }).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '로그인에 실패하였습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {

            axios.post('https://api.mypathkr.com/oauth/redir', {
              'client_id': is_report ? 'study_report' : "usersite",
              'redirect_uri': is_report ? 'https://bizstudy.useschool.co.kr/login/login_ok.asp' : 'https://bizstudy.useschool.co.kr/intro.asp'
            }, {
              headers: {
                "Authorization": "Bearer " + response.data.access_token
              }
            }).then((response) => {
              if (response.data.error) {
                $.notify({
                  // options
                  message: '학습관 인증에 실패하였습니다. ' + response.data.error
                }, {
                  // settings
                  type: 'danger',
                  z_index: 9999
                });
              } else {
                $.notify({
                  // options
                  message: '학습관으로 리다이렉트 중입니다.'
                }, {
                  // settings
                  type: 'danger',
                  z_index: 9999
                });
                window.open(response.data.url, '_blank')
              }


            })

          }


        })

      },
      delMemo(memo) {
        axios.delete('/students/' + this.Tstudent.id + '/memos/' + memo).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '삭제 실패하였습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            $.notify({
              // options
              message: '삭제 성공하였습니다. '
            }, {
              // settings
              type: 'success',
              z_index: 9999
            });
            this.moreStudentInfo(this.Tstudent);

          }


        })
      },
      addMemo(record) {
        axios.post('/students/' + this.Tstudent.id + '/memos', {
          "memo": this.Tstudent.memo,
          "expiresAt": 0
        }).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '작성 실패하였습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            $.notify({
              // options
              message: '작성 성공하였습니다. '
            }, {
              // settings
              type: 'success',
              z_index: 9999
            });
            this.moreStudentInfo(this.Tstudent);

          }


        })
        this.Tstudent.memo = "";
      },
      openModal() {
        this.active = true;
        this.moreStudentInfo(this.Tstudent);
        //학습점수초기세팅
        this.Psub.chrGubun = "P";
        this.Psub.chrPType = "";
        this.Psub.intPoint = "";
        this.Psub.setPoint = "";
        this.Psub.strHistory = "";    
      
        this.$nextTick(function(){
          var modalDom = document.getElementById("Modal" + this.TbtnId);
          var modal = (bootstrap.Modal.getOrCreateInstance(modalDom));
          modalDom.addEventListener('hidden.bs#Modal', function (event) {
            this.active = false;
          })
          modal.show();
        });
        this.fetchSubscriptions()

      },
      requestLevel(type) {

        if(this.levelRequest.level == 'RE'){
            this.levelRequest.level = this.levelRequest.record.level;
          }
          //alert(type);
          //return;
       if(type ==="chng"){        
          //console.log(this.levelRequest.level);
          axios.patch('/subscriptions/' + this.levelRequest.record.id, {
            'level': this.levelRequest.level
          }).then((response) => {
            if (response.data.error) {
              $.notify({
                // options
                message: '변경실패: ' + response.data.error
              }, {
                // settings
                type: 'danger',
                z_index: 9999
              });
            } else {
              $.notify({
                // options
                message: response.data.status == "requested" ? "변경 요청되었습니다. " : "변경되었습니다."
              }, {
                // settings
                type: 'success',
                z_index: 9999
              });
              this.moreStudentInfo()

            }


          })
        
      }else if(type ==="req"){
        //중고등상품 레벨벨변경신청만
       // console.log("level:"+this.levelRequest.level);
        console.log("record:"+this.levelRequest.record.id);
       // return;
        axios.post('/subscriptions/reqLvl/' + this.levelRequest.record.id, {
            'level': this.levelRequest.level
          }).then((response) => {           
            if (response.data.error) {
              $.notify({
                // options
                message: '변경실패: ' + response.data.error
              }, {
                // settings
                type: 'danger',
                z_index: 9999
              });
            } else {
              $.notify({
                // options
                message: response.data.status == "ok" ? "신청이 완료되었습니다. " : "변경되었습니다."
              }, {
                // settings
                type: 'success',
                z_index: 9999
              });
              this.moreStudentInfo()

            }


          })

      }else{
        //과목변경신청하기
        var subject_arr_update = "";
        var cnt = 0;
        if(this.LA === true){
          subject_arr_update = "LA,";
          cnt++;
        } 
        if(this.MA === true){
          subject_arr_update = subject_arr_update + "MA,";
          cnt++;
        }
        if(this.SC === true){
          subject_arr_update = subject_arr_update + "SC,";
          cnt++;
        }
        if(this.SS === true){
          subject_arr_update = subject_arr_update + "SS,";
          cnt++;
        }
        //console.log("subject_arr_update:"+subject_arr_update);
        //console.log("cnt:"+parseInt(cnt));
        //console.log("subject_cnt:"+parseInt(this.Tstudent.subject_cnt));
        
        if(parseInt(cnt) !== parseInt(this.Tstudent.subject_cnt)){
          alert('선택할 수 있는 과목수가 다릅니다. 확인해주세요.\n(선택 가능한 과목수: '+this.Tstudent.subject_cnt+'개)');
          return;
        }    
        //console.log("srcLevel:"+this.Tstudent.subject_arr);
        //console.log("dstLevel:"+subject_arr_update);
        //console.log("subsc:"+JSON.stringify(this.subsc));
        //console.log("record:"+this.subsc[0].id);
        //return;
        axios.post('/subscriptions/reqSub/' + this.subsc[0].id, {
            "srcLevel": this.Tstudent.subject_arr,
            "dstLevel": subject_arr_update
          }).then((response) => {   
            if (response.data.error) {
              $.notify({
                // options
                message: '변경실패: ' + response.data.error
              }, {
                // settings
                type: 'danger',
                z_index: 9999
              });
            } else {
              $.notify({
                // options
                message: response.data.status == "ok" ? "신청이 완료되었습니다. " : "변경되었습니다."
              }, {
                // settings
                type: 'success',
                z_index: 9999
              });
              this.moreStudentInfo()

            }


          })

      }



      },
            checkDeleteAvailable(record) {
        this.Tstudent = record;
        this.showDeleteWarns = false;
        this.deletingErrors = [{
            "level": "ERROR",
            "error": "삭제 가능 여부를 조회 중입니다. 잠시만 기다려 주세요.",
            "error_code": "FETCHING_DELETE",
            "type": "LOADING",
            "data_id": "",
            "data_name": "시스템"
          },
          {
            "level": "ERROR",
            "error": "일관성 검사 절차가 들어있어 최장 10초 소요될 수 있습니다.",
            "error_code": "FETCHING_DELETE",
            "type": "LOADING",
            "data_id": "",
            "data_name": "시스템"
          }
        ];
        this.deletingPermitted = false;
        axios.get('/students/' + record.id + '/preCheckBeforeDelete').then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            //에러와 오류로 분리
            this.errCnt = 0;
            this.warnCnt = 0;
            this.deletingErrors = response.data.errors;
            if (response.data.errors.length) {
              response.data.errors.forEach(element => {
                if (element.level == "ERROR") {
                  this.errCnt++;
                } else {
                  this.warnCnt++;
                }
              });
            }

            if (this.errCnt) {
              this.deletingErrors.push({
                "level": "ERROR",
                "error": "1개 이상의 오류로 학생을 삭제할 수 없습니다.",
                "error_code": "ERROR",
                "type": "LOADING",
                "data_id": "",
                "data_name": "시스템"
              });
              this.deletingPermitted = false;
            } else {
              this.deletingErrors.push({
                "level": "SUCCESS",
                "error": "학생을 삭제할 수 있습니다.",
                "error_code": "SUCCESS",
                "type": "LOADING",
                "data_id": "",
                "data_name": "시스템"
              });
              this.deletingPermitted = true;
            }
          }

        })
      },
      nvl(str, altStr){
        if(typeof str == "undefined" || str == null) str = altStr ;
         return str ;

      },
      commitDelete(record) {
        axios.delete('/students/' + record.id).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '삭제 실패하였습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            $.notify({
              // options
              message: '삭제 성공하였습니다. '
            }, {
              // settings
              type: 'success',
              z_index: 9999
            });
            this.Tstudent.deleted = true;
            this.search()


          }


        })


      },
      requestExtend() {
        // 기존 상품의 데이터를 토대로 새로운 주문을 넣기
        axios.post('/subscriptions', {
          "hopeStart": this.extendRequest.record.endDate,
          "level": this.extendRequest.record.level,
          "paymentMethod": this.extendRequest.payMethod,
          "product": this.extendRequest.product.id,
          "student": this.Tstudent.id,
          "previous_order": this.extendRequest.record.id,
         "subject":""
        }).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '연장 실패하였습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            $.notify({
              // options
              message: '연장신청 성공하였습니다. '
            }, {
              // settings
              type: 'success',
              z_index: 9999
            });
            this.moreStudentInfo(this.Tstudent);

          }


        })

      },
            fetchProducts(source) {
        var extras = "?";
        if (source) {
          extras += "source=" + source.id
        }
        axios.get('/products' + extras).then((response) => {
          if (response.data.error) {
            $.notify({
              // options
              message: '데이터를 조회할 수 없습니다. ' + response.data.error
            }, {
              // settings
              type: 'danger',
              z_index: 9999
            });
          } else {
            this.products = response.data.result;
          }


        })
      },

    },
    components: {
      Tree,
      treeBtn,
        Subscription,
        QueryGrid,
        CreateSubscription,
        CreateSubscription_new
    },
    mounted() {
      this.Tstudent = this.student;
      this.config_subscriptions.extras_addon =  async ()=>{
      return "&student=" + this.student.id
    }
    },
    props: {
      student: {
        type: Object,
        default: {}
      },
      btnId: String
    },
    data() {
      return {
        config_subscriptions: {
    "name": "아이디 주문들_특정학생",
    "req_endpoint": "/subscriptions",
    "default_limit": 20,
    "disable_init_search": true,
    "search_fields": [
        {
            "id": "date_filter",
            "name": "날짜검색",
            "type": "date",
            "filter_type": {
                "created_at": "신청일",
                "start_date": "시작일",
                "end_date": "종료일"
            }
        },
        {
            "id": "status_filter",
            "name": "상태",
            "type": "switch",
            "filter_type": {
                "WAITING_PAYMENT": "결제 대기 중",
                "PAYMENT_LATE": "결제 만료",
                "CONFIRMING_PAYMENT": "결제 확인 중",
                "PENDING": "대행 대기 중",
                "ACTIVE": "사용 중",
                "ENDED": "만료",
                "CANCEL_PENDING": "취소 대기 중",
                "CANCELLED": "취소됨",
                "RESERVED": "연장"
            }
        },
        {
            "id": "paymethod_filter",
            "name": "결제 방법",
            "type": "switch",
            "filter_type": {
                "CARD_ONPG": "ON 신용카드",
                "CARD_OFFPG": "OFF 신용카드",
                "CASH": "현금"
            }
        },
        {
            "id": "search",
            "name": "키워드검색",
            "type": "text",
            "placeholder": "주문번호"
        }
    ],
    "columns": [
        {
            "id": "order_id",
            "sortable": true,
            "name": "주문번호",
            "excel_print": v=>{return v.orderId + (v.previous_order ? '[연장]' : '')}
        },
        {
            "id": "created_at",
            "sortable": true,
            "name": "신청일",
            "excel_print": v=>{return v.createdAt}
        },
        {
            "id": "product_name",
            "sortable": true,
            "name": "상품명",
            "excel_print": v=>{return v.productName}
        },
        {
            "id": "period",
            "sortable": true,
            "name": "기간",
            "excel_print": v=>{return v.period}
        },
        {
            "id": "level",
            "sortable": true,
            "name": "과정",
            "excel_print": v=>{return v.level}
        },
        {
            "id": "payment_method",
            "sortable": true,
            "name": "결제방법",
            "excel_print": v=>{var a={"CASH":"현금","CARD_ONPG":"온라인 카드","CARD_OFFPG": "오프라인 카드"};return a[v.paymentMethod]}
        },
        {
            "id": "price",
            "sortable": true,
            "name": "금액",
            "excel_print": v=>{return v.price}
        },
        {
            "id": "end_date",
            "sortable": true,
            "name": "종료일",
            "excel_print": v=>{return v.endDate}
        },
        {
            "id": "status",
            "sortable": true,
            "name": "상태",
            "excel_print": v=>{var a={
                "WAITING_PAYMENT": "결제 대기 중",
                "PAYMENT_LATE": "결제 만료",
                "CONFIRMING_PAYMENT": "결제 확인 중",
                "PENDING": "대행 대기 중",
                "ACTIVE": "사용 중",
                "ENDED": "만료",
                "CANCEL_PENDING": "취소 대기 중",
                "CANCELLED": "취소됨",
                "RESERVED": "연장"
            };return a[v.status]}
        }
    ]
},
        levelRequest: {
          subId: "",
          request: "",
          record: {

          },
          level: ""
        },
        changedData: {},
        TbtnId: this.btnId || Math.random().toString().substr(2, 5),
        selBiz: {
          "name": ""
        },
        selHistory: [],
        dhistorys: [],
        Tstudent: {},       
        AccDatas: [],
        selectedSubscription: {
          id: 0
        },
        admCheck: [],
        strGrade: "",
        strSubject: "",
        intMemberID: "",
        historys: [],
        tests: [],
        active: false,

        levelRequest: {
          subId: "",
          request: "",
          record: {

          },
          level: ""
        },
        strGrade: "",
        strSubject: "",
        intMemberID: "",
        historys: [],
        tests: [],
        admCheck: [],
        showDeleteWarns: false,
        deletingErrors: null,
        deletingPermitted: false,
        errCnt: 0,
        warnCnt: 0,
        showWarn: false,
        extendRequest: {
          record: {}
        },

        selProduct: {

        },
        selectedSubscription: {
          id: 0
        },
        subscriptions: [],
        products: [],
        recommender_id: "",
        Psub:{
            "chrGubun": "P",
            "chrPType": "",
            "setPoint": "",
            "intPoint": "",
            "strHistory": ""                
            }
      }
    }
  }
</script>

<style>

</style>
